import React from 'react';
import classes from './Header.module.scss';
import Navbar from '../Navbar/Navbar';

const Header = () => {
  return (
    <div className={classes.Header}>
      <div className={classes.Logo}>
        <h1 className={classes.LogoText}>Photography</h1>
      </div>

      <Navbar />
    </div>
  );
}

export default Header;
